import * as psl from 'psl';

export function hasUnmatchingDomains(from: string, returnPath: string) {
  if (!returnPath || !from || returnPath.indexOf("@") === -1 || from.indexOf("@") === -1) {
    return true;
  }

  const fromInput = from.toLowerCase().split('@')[1].replace('>', '').trim();
  const returnPathInput = returnPath ? returnPath.toLowerCase().split('@')[1].replace('>', '').trim() : '';

  // comparing domain names (second level domain + top level domain)
  return psl.get(fromInput) !== psl.get(returnPathInput);
}



// WEBPACK FOOTER //
// ./src/components/mail/util/message.util.ts